// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill";

// 引入jquery
import $ from 'jquery'

// 引入bootstrap
import './assets/libs/bootstrap/css/bootstrap.min.css'
import './assets/libs/bootstrap/js/bootstrap.min'
import 'swiper/dist/css/swiper.css'

import vueScrollBehavior from 'vue-scroll-behavior'
// import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole

// let vConsole = new VConsole() // 初始化
 
// 当切换到新路由时，想要页面滚到顶部，或者是保持原先的滚动位置
Vue.use(vueScrollBehavior, { router: router })

/*清除浏览器默认样式*/
var resetCss = require('./assets/css/common.css');

Vue.config.productionTip = false

// Vue.prototype.HOST = "/api";
Vue.prototype.HOST = process.env.API_ROOT;


//过滤器
Vue.filter("date", function(val) {
    var twoNumber = function(n) {
        if (n < 10) {
            return "0" + n;
        } else {
            return n;
        }
    }
    if (!val) { return '' }
    //转换成标准格式日期
    val = val.replace(/\-/g, '/');
    var date = new Date(val);
    var datestr = date.getFullYear() + "年" + twoNumber(date.getMonth() + 1) + "月" + twoNumber(date.getDate());
    return datestr;
})

//引入公共组件
import VHeader from "./components/header"
import VHearder2 from "./components/header2.vue"
import VFooter from "./components/footer"
import VFooter2 from "./components/footer2"
import GotoTop from "./components/gotoTop"
import ProductTool from "./components/product_tool.vue"

//注册全局组件
Vue.component('v-header', VHeader);
Vue.component('v-header2', VHearder2)
Vue.component('v-footer', VFooter);
Vue.component('goto-top', GotoTop);
Vue.component('v-footer2', VFooter2);
Vue.component('product-tool', ProductTool);


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js